<template>
  <div class="inner">
    <div>
      <v-card class="card-wrap">
        <p class="text-center my-2 pointer" @click="forward(instance)">{{ instance.alias }}</p>
      </v-card>
      <v-sheet class="d-flex" :color="instance.color" height="5"></v-sheet>
    </div>
    <div style="height: calc(100% - 65px)">
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>User</v-card-title>
          <div class="box">
            <user :instance="instance" :typeColors="userTypeColors" />
          </div>
        </v-card>
      </div>
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>Performance</v-card-title>
          <div class="box">
            <performance :instance="instance" />
          </div>
        </v-card>
      </div>
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>Work Process</v-card-title>
          <div class="box">
            <workprocess :instance="instance" :statusColors="wpStatusColors" :typeColors="wpTypeColors" />
          </div>
        </v-card>
      </div>
      <div class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>OS</v-card-title>
          <div class="box">
            <os :instance="instance" />
          </div>
        </v-card>
      </div>
      <div v-if="instance.centralInstance" class="h-20 mt-1">
        <v-card class="card-wrap">
          <v-card-title>Lock</v-card-title>
          <div class="box">
            <lock :instance="instance" />
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import User from './User.vue';
import Performance from './Performance.vue';
import Workprocess from './Workprocess.vue';
import Os from './Os.vue';
import Lock from './Lock.vue';
import instanceable from './mixins/instanceable';

export default {
  mixins: [instanceable],
  components: {
    User,
    Performance,
    Workprocess,
    Os,
    Lock,
  },
  props: {
    // BEGIN::Added.by.KWShin.2024.02.14.
    userTypeColors: {
      type: String,
      required: true,
    },
    wpStatusColors: {
      type: String,
      required: true,
    },
    wpTypeColors: {
      type: String,
      required: true,
    },
    // FINISH::Added.by.KWShin.2024.02.14.
  },
  computed: {
    ...mapState('common/menu', ['realtime']),
    ...mapGetters('common/system', ['getDescendantsById']),
  },
  methods: {
    forward(p) {
      const [{ children: realtimeChildMenus }] = this.realtime;
      const { children: overviewChildMenus } = realtimeChildMenus[0];
      const sstmOvMenu = overviewChildMenus.find(m => m.url.startsWith('/views/overview/system'));

      const query = this.getDescendantsById(p.systemId).length > 1 ? { d: p.id } : {};

      this.$router.push({ path: `${sstmOvMenu.url}/${p.systemId}`, query });
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
